export interface MerchantHoursDay {
  allDay: boolean;
  closed: boolean;
  ranges: { open: string; close: string }[];
}

export const MERCHANT_HOURS_RANGE_ERROR = '请填写有效且不同的起止时间；全天营业请选择“全天营业”';

/** 结束时间早于开始时间表示次日结束；相同时不推断为全天营业。 */
export function isValidMerchantHoursRange(open: string, close: string): boolean {
  const regularTime = /^(?:[01]\d|2[0-3]):[0-5]\d$/;
  return regularTime.test(open) && (regularTime.test(close) || close === '24:00') && open !== close;
}

export function isOvernightMerchantHoursRange(open: string, close: string): boolean {
  return isValidMerchantHoursRange(open, close) && close < open;
}

export function merchantHoursClosingLabel(open: string, close: string): string {
  return isOvernightMerchantHoursRange(open, close) ? `次日${close}` : close;
}

export function merchantHoursRangeLabel(open: string, close: string, separator = '–'): string {
  return `${open}${separator}${merchantHoursClosingLabel(open, close)}`;
}

export function isBlankMerchantHoursDay(day?: MerchantHoursDay): boolean {
  return (
    !day ||
    (!day.allDay &&
      !day.closed &&
      (!day.ranges?.length ||
        day.ranges.every((range) => !range.open && !range.close)))
  );
}

/** 空白表示未提供营业时间，不推断为全天营业或休息日。 */
export function merchantHoursError(
  hours: Record<string, MerchantHoursDay>,
): string {
  const days = [
    ['monday', '周一'],
    ['tuesday', '周二'],
    ['wednesday', '周三'],
    ['thursday', '周四'],
    ['friday', '周五'],
    ['saturday', '周六'],
    ['sunday', '周日'],
  ] as const;
  for (const [key, label] of days) {
    const day = hours[key];
    if (isBlankMerchantHoursDay(day) || day.closed || day.allDay) continue;
    for (const range of day.ranges) {
      if (!range.open || !range.close) return `${label}营业时间未填写完整`;
      if (!isValidMerchantHoursRange(range.open, range.close)) {
        return `${label}：${MERCHANT_HOURS_RANGE_ERROR}`;
      }
    }
  }
  return '';
}

/** 显式发送空对象，确保编辑及修改审核可以清空旧值。 */
export function serializeMerchantHours(
  hours: Record<string, MerchantHoursDay>,
): string {
  return JSON.stringify(
    Object.fromEntries(
      Object.entries(hours).filter(([, day]) => !isBlankMerchantHoursDay(day)),
    ),
  );
}
